(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.lbrReady) return;
      root.dataset.lbrReady = '1';
      const slides = [...root.querySelectorAll('.lbr-hero__slide')];
      const dots = [...root.querySelectorAll('.lbr-hero__dot')];
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const show = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
      };
      const seconds = parseInt(root.dataset.autoplay, 10) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const start = () => {
        if (!seconds || reduce) return;
        clearInterval(timer);
        timer = setInterval(() => show(index + 1), seconds * 1000);
      };
      dots.forEach((d) =>
        d.addEventListener('click', () => {
          show(parseInt(d.dataset.index, 10));
          start();
        })
      );
      root.addEventListener('mouseenter', () => clearInterval(timer));
      root.addEventListener('mouseleave', start);
      start();
    };
    document.querySelectorAll('.lbr-hero').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.lbr-hero')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
